import Vue from "vue";
import axios from 'axios';

const customAPI = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Accept': 'application/json, text/plain, */*',
    'ClientId': 'ptdClientApp'
  },

});


//---request interceptor
customAPI.interceptors.request.use(function (config) {
  config.headers['Content-Type'] = 'application/json';
  return config;
}, function (error) {
  return Promise.reject(error);
});

//---response interceptor
customAPI.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return Promise.reject(error);
});

Vue.axios = customAPI;